<template>
    <div
        class="intro-container"
        :style="{ backgroundImage: 'url(' + imageUrl(heroImage) + ')' }"
    >
        <logo></logo>
        <p>
            <strong class="large">Meet your pocket-sized personal stylist.</strong>
        </p>
        <div class="wtw-container small">
            <div class="buttons-container">
                <router-link to="/signup/1" class="button pink"
                    >Get Started</router-link
                >
                <router-link
                    :to="{ name: 'login', params: { fromIntro: true } }"
                    class="button transparent outline"
                    >Sign In</router-link
                >
            </div>
        </div>
        <!-- <router-link to="/login" class="shop small-font white">Shop without an account</router-link>-->
    </div>
</template>

<script>
import Logo from "../header/logo.vue";
import Mixins from "../../mixins/mixins.js";

export default {
    data() {
        return {
            heroImage: "intro-hero.png",
        };
    },
    created() {
        /* Temporary -- just to force log out when clicking logout from menu */
        this.$store.commit("cart/resetState");
        this.$store.commit("filters/resetState");
        this.$store.commit("generatedOutfits/resetState");
        this.$store.commit("onboarding/resetState");
        this.$store.commit("products/resetState");
        this.$store.commit("savedOutfits/resetState");
        this.$store.commit("savedProducts/resetState");
        this.$store.commit("outfits/resetState");
        this.$store.commit("auth/logOut");
    },
    mixins: [Mixins],
    components: { Logo },
};
</script>
